import { CompleteDataGeneralComponent } from './../../admin/users/complete-data-general/complete-data-general.component';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {TranslateService} from 'ng2-translate/ng2-translate';
import {LoginService} from '../../services/login.service';
import {ProvidersService} from '../../services/providers.service';
import {RecoverComponent} from '../recover/recover.component';

import * as decode from 'jwt-decode';
import { id } from '@swimlane/ngx-datatable/release/utils';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
  @ViewChild('passInput', { static: false }) passInput;
  user: any = {};
  userMail: string;
  newPass: string;
  newPassConfirm: string;
  loadBtn = false;
  recoverPass = false;
  typePage = 'login';
  dataLog: any;


  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;
  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'es';
  public type: 'image' | 'audio';

  activeLogin=true;
  deviceInfo = "";
  errosTostr:any;

  language = 'es';

  constructor(private toastr: ToastrService,
              public  dialog: MatDialog,
              private router: Router,
              private authService: LoginService,
              public  translate: TranslateService,
              private provService: ProvidersService,
              private deviceService: DeviceDetectorService) {
              translate.addLangs(['es', 'en']);
              translate.setDefaultLang('es');

                const browserLang: string = translate.getBrowserLang();
                  translate.use(browserLang.match(/en|fr|es/) ? browserLang : 'es');
                  localStorage.setItem('language', 'es');

                const x = window.matchMedia('(max-width: 768px)');
                this.myFunction(x);

                this.deviceInfo = this.deviceService.browser;
                console.warn(this.deviceService.browser)
  }

  ngOnInit() {
    this.translate.getTranslation(this.language).subscribe((res:any)=>{
      this.errosTostr = res.ERRORTOASTR;
    });

    if( this.deviceInfo.toUpperCase()  == 'CHROME'){
      this.activeLogin=true;
    }else if( this.deviceInfo.toUpperCase() == 'FIREFOX'){
      this.activeLogin=true;
    }else if( this.deviceInfo.toUpperCase() == 'SAFARI'){
      this.activeLogin=true;
    }else{
      this.activeLogin=false;
    }

  }

  translateLang(lang){
    let tempLang = localStorage.setItem('language', lang);
  }

  myFunction(x) {
    if (x.matches) { // cel
      this.size = 'compact';
    } else {// web
      this.size = 'normal';
    }
  }


  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.captchaIsExpired = false;
    // console.log('handleSuccess',captchaResponse);
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.captchaIsExpired = false;
    // console.log('handleLoad');
  }

  handleExpire(): void {
    this.captchaSuccess = false;
    this.captchaIsExpired = true;
    // console.log('handleExpire');
  }


  login(){
    this.toastr.clear();

    if(!this.user.username || !this.user.password){
      this.toastr.error( this.translate.instant('LOGIN.EUSERPASS') , this.translate.instant('LOGIN.LOGFAILED') );
      return;
    }

    if(!this.captchaSuccess || this.captchaIsExpired){
      this.toastr.error( this.translate.instant('LOGIN.ECAPTCHA') , this.translate.instant('LOGIN.LOGFAILED') );
      return;
    }
    this.loadBtn = true;
    this.user.grant_type = 'password';

    this.authService.login(this.user).then((data) => {
      const tokenPayload = decode(data['access_token']);

      // if(tokenPayload.ValidarDatosProveedor){
      //   this.complementInfo(data['access_token']);
      //   return;
      // }
      console.warn(localStorage.getItem('language') );
      localStorage.setItem('G13xTfsdf234TVsd23513ffdgFdf2352', 'Bearer '+data['access_token']);

      this.router.navigate(['/', 'inicio']);
      if(tokenPayload.IdPerfil == 3){
        this.provService.getMessages( tokenPayload.IdProveedor,
                                      tokenPayload.Id,
                                      localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352')).then((dataMsg) => {
          if(dataMsg['EsValido']){
            if(dataMsg['Entidad'].Mensaje.length > 0){
              for(let g = 0; g < dataMsg['Entidad'].Mensaje.length; g++){
                console.log(dataMsg['Entidad'].Mensaje[g]);
                if(dataMsg['Entidad'].Mensaje[g].Key == 'ERROR'){
                  this.toastr.error(dataMsg['Entidad'].Mensaje[g].Value, '', {disableTimeOut: true, closeButton: true});
                }
                if(dataMsg['Entidad'].Mensaje[g].Key == 'WARNING'){
                  this.toastr.warning(dataMsg['Entidad'].Mensaje[g].Value, '', {disableTimeOut: true, closeButton: true});
                }
                if(dataMsg['Entidad'].Mensaje[g].Key == 'OK'){
                  this.toastr.success(dataMsg['Entidad'].Mensaje[g].Value, '', {disableTimeOut: true, closeButton: true});
                }
              }
            }
          }
        }, (err) => {
          console.log(err);
        });
      }
      this.loadBtn = false;
    }, (err) => {
      console.log(err['error'].msg);
      this.loadBtn = false;
      this.toastr.error( this.translate.instant('LOGIN.IUSERPASS') ,
                         this.translate.instant('LOGIN.LOGFAILED') ,
                         {timeOut: 18000, enableHtml: true} );
    });
  }


  recover(){

    this.toastr.clear();

    if(!this.userMail){
      this.toastr.error( this.translate.instant('LOGIN.ENTEMAIL') , this.translate.instant('LOGIN.ERECPASS') );
      return;
    }
    this.loadBtn = true;
    let  param =  {Usuario: this.userMail}
    this.authService.recover(param).then((data) => {

      this.toastr.success( this.translate.instant('LOGIN.EMASENPAS') , this.translate.instant('LOGIN.RECOVERPASS'));
      this.loadBtn = false;
      this.recoverPass = false;
      this.userMail = '';
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.toastr.error(err, this.translate.instant('LOGIN.ERECPASS') );
    });
  }

  change(){
    if(!this.newPassConfirm || !this.newPass){
      this.toastr.error( this.translate.instant('LOGIN.CONFPASS') , this.translate.instant('LOGIN.EPASSCHA') );
      return;
    }

    if(this.newPassConfirm != this.newPass){
      this.toastr.error( this.translate.instant('LOGIN.PASSDIFF') , this.translate.instant('LOGIN.EPASSCHA') );
      return;
    }

    this.loadBtn = true;

    this.authService.changePass({password: this.newPass}, this.dataLog.id, this.dataLog.session_token).then((data) => {
      this.toastr.success( this.translate.instant('LOGIN.EMASENPAS') , this.translate.instant('LOGIN.CHANGEPASS') );
      this.loadBtn = false;
      const datenc = encodeURIComponent(JSON.stringify(this.dataLog));
      localStorage.setItem('G13xTfsdf234TVsd23513ffdgFdf2352', datenc);
      if(this.dataLog.type == 'provider'){
        this.router.navigate(['/', 'inicio']);// mandar a su informacion para que la valide
      }else{
        this.router.navigate(['/', 'inicio']);
      }
    }, (err) => {
      console.log(err['error'].msg);
      this.loadBtn = false;
      this.toastr.error(err['error'].msg, this.translate.instant('LOGIN.ERECPASS') );
    });
  }

}
